var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ui primary button",on:{"click":function($event){return _vm.persist()}}},[_vm._v("Job befindet sich in Produktion")])
}
var staticRenderFns = []

export { render, staticRenderFns }